import React from 'react';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import MessagePropType from '../definitions/MessagePropType';
import { VARIANTS, GLAMAZON_STYLES } from '../styles/AnchorStyles';

import TextElement from './TextElement';


function TextAnchor({
    message,
    children,
    href,
    variant = VARIANTS.DARK,
    disabled,
    onClick,
    size = SIZES.XLARGE,
    ...otherProps
}) {
    return (
        <TextAnchorContainer
            href={disabled
                ? undefined
                : href}
            variant={variant}
            disabled={disabled}
            onClick={onClick}
            {...otherProps}
        >
            <TextElement
                as="span"
                className={classNames(
                    'text-wrapper',
                    {
                        'rh-text-s': size === SIZES.SMALL,
                        'rh-text-m': size === SIZES.MEDIUM,
                        'rh-text-l': size === SIZES.LARGE,
                        'rh-text-xl': size === SIZES.XLARGE,
                    },
                )}
                message={message}
            >
                {children}
            </TextElement>
        </TextAnchorContainer>
    );
}

const SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XLARGE: 'xlarge',
};

TextAnchor.propTypes = {
    message: MessagePropType,
    children: PropTypes.node,
    href: PropTypes.string,
    variant: PropTypes.oneOf(Object.values(VARIANTS)),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(Object.values(SIZES)),
};

const TextAnchorContainer = styled.a`
    ${GLAMAZON_STYLES};

    cursor: pointer;
`;

TextAnchor.VARIANTS = VARIANTS;
TextAnchor.SIZES = SIZES;

export default observer(TextAnchor);
